<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper search-product-result">
      <app-header>
        <div class="search-bar" slot="header-foot">
          <button @click="goBack()" class="button is-flex nav-back">
            <svg width="11px" height="17px" viewBox="0 0 11 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="cat_items_arrrow_left" transform="translate(-17.000000, -113.000000)" fill="#302F30">
                      <g id="Icon/Arrow/Line/Left" transform="translate(17.000000, 113.000000)">
                          <g id="Arrow" transform="translate(5.500000, 8.500000) scale(-1, 1) rotate(-90.000000) translate(-5.500000, -8.500000) translate(-2.500000, 3.500000)">
                              <path d="M12.7512595,-2.66130014 C12.3864007,-3.07503886 11.7553807,-3.11530894 11.3408693,-2.75130761 L3.33865585,4.24927355 C3.12334585,4.43912235 3,4.71231141 3,4.99933582 C3,5.28636023 3.12334585,5.55954928 3.33865585,5.74939808 L11.3408693,12.7499792 C11.523224,12.9107703 11.7579123,12.9996502 12.0010519,13 C12.2883586,12.9996363 12.5616372,12.8757739 12.7512595,12.6599718 C13.1153313,12.2455407 13.0750534,11.6146428 12.6612346,11.2498547 L5.51925902,4.99933582 L12.6612346,-1.25118308 C13.0750534,-1.61597117 13.1153313,-2.24686907 12.7512595,-2.66130014 Z" id="Path" transform="translate(8.000000, 5.000000) scale(-1, 1) rotate(-90.000000) translate(-8.000000, -5.000000) "></path>
                          </g>
                      </g>
                  </g>
              </g>
            </svg>
          </button>

          <div class="control search-input has-background-white">
            <span class="icon is-fullheight">
              <img src="@/assets/img/icon-search.svg" alt="Search" />
            </span>
            <input
              @keyup.enter="searchProduct($event)"
              class="input is-fullheight is-borderless is-shadowless"
              v-model="searchText"
              type="text"
              placeholder="Search..."
            />
            <a v-if="searchText" href="#" @click.prevent="resetFilterText()" class="btn-close is-small"></a>
          </div>
          <button
            class="button is-filter-toggle"
            @click.prevent="activeFilter = !activeFilter"
          >Filter</button>
        </div>
      </app-header>

      <main class="content-wrapper is-relative has-background-white-bis pb0">
        <div class="columns ml0 mr0 flex-grow-1">

          <!-- Search Results Content -->
          <div class="column flex-grow-1 section-search-results" v-if="is_loading">
            <loading></loading>
          </div>
          
          <template v-else>
            <div class="column flex-grow-1 section-search-results">
              <div class="container xl">
                <section class="columns is-centered">

                  <div
                    class="column search-result-column"
                    v-if="searchedProducts.length > 0"
                  >
                    <div class="wrap-is-constant-240px"> <!--  wrapper-675px -->
                      
                      <div class="is-constant-240px" 
                        v-bind:key="itemIndex + '-item'" 
                        v-for="(item, itemIndex) in searchedProducts">
                          
                        <template v-if="!item.discontinued">
                          <weed-card 
                            v-if="item.product_family == 'cannabis'" 
                            :callback="goToLocationProductDetail" 
                            :item="item" 
                          ></weed-card>

                          <accessory-card 
                            v-else
                            :callback="goToLocationProductDetail" 
                            :item="item" 
                          ></accessory-card>
                        </template>

                      </div>

                      <!-- <template v-for="(item, itemIndex) in searchedProducts">
                        <item  v-if="!item.discontinued" v-bind:key="itemIndex + '-item'" :callback="goToLocationProductDetail" :item="item"></item>
                      </template> -->
                    </div>
                  </div>
                  <div class="column is-9-widescreen is-8-fullhd is-11-desktop" v-else>
                    <p class="text-center">No Product Found.</p>
                  </div>
                </section>
              </div>
            </div>
          </template>
        </div>

        <!-- Modal: Filter form (is-active to activate the modal) -->
        <filter-product v-show="activeFilter" :results="searchedProducts.length"></filter-product>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";
//import List from "@/Components/Pages/PageComponents/SearchProductResult/List";
import Item from "@/Components/Pages/PageComponents/SearchProductResult/ItemV2";
import FilterProduct from "@/Components/Pages/PageComponents/SearchProductResult/FilterProduct";
import LocationApis from '@/Components/Controllers/LocationApis';
import SearchProductApis from '@/Components/Controllers/SearchProductApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import UserApis from '@/Components/Controllers/UserApis';

export default {
  components: {
    Item,
    FilterProduct
  },
  name: "SearchProductResult",
  data() {
    return {
      searchCount: 0,
      is_loading: false,
      searchText: "",
      productForm: "",
      productFormCategories: [
        "dried flower",
        "pre rolled",
        "oil",
        "spray",
        "capsules"
      ],
      activeFilter: false,
      count: null,
      searchedProducts: [],
      searchedStores: [],
      nearestLocationArray: [],
      productCountAfterValidations: 0,
    };
  },

  created() {
    // Set the location to blank so that on header it do not show old location, on mount we are refetching and setting selected location
    // this.va_setSelectedLocation({});
  },

  async mounted() {

    this.is_loading = true;
    bus.$on('close-filter', (payload) => {
      this.activeFilter = payload;
    })
    this.searchText = this.$route.query.product_name ? this.$route.query.product_name : '';
    this.productForm = this.$route.query.product_form ? this.$route.query.product_form : '';
    // If product type is not one of the following, activate filter
    if (_.indexOf(this.productFormCategories, this.productForm) > -1) {
      let filter = this.vg_searchFilter;
      if(_.indexOf(filter.product_form, this.productForm) == -1){
        filter.product_form.push(this.productForm);
        this.va_setSearchFilter(filter);
      }
    }

    // let businessRes = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
    // if(businessRes.status != 200){
    //   // Its invalid business redirect to valid one
    //   this.va_snackbar({
    //     type: "warning",
    //     message: "Cannot find business."
    //   });
    //   return this.$router.push({ 
    //     name: 'HomePage', 
    //     params: {
    //       business_slug: Env.defaultBusinessSlug 
    //     },
    //     query: this.$route.query,
    //   });
    // }


     // Fetch store detail by slug
    // let locationRes = await LocationApis.fetchBySlug(this.$route.params.store_slug);
    // if (locationRes.status != 200) {
    //   this.va_snackbar({
    //     type: "warning",
    //     message: "Cannot find the store for the business."
    //   });
    //   return this.$router.push({
    //     name: 'HomePage',
    //     query: this.$route.query,
    //   })
    // }
    // this.va_setSelectedLocation(locationRes.data.payload);
    
    let location_id = this.vg_selectedStore.id;
    if (!location_id) {
      this.locationNotFound = true;
      this.va_snackbar({
        type: "warning",
        message: "Cannot find the store."
      });
      return false;
    }

    // Search product
    await this.searchProduct();
    this.searchCount++; 
    if(this.vg_userId) {
      UserApis.fetchFavProducts();
    }
    

  },
  
  beforeDestroy() {
    bus.$off('close-filter');
    bus.$off('search-text-changed');
  },

  watch: {
    vg_doSearch() {
      if(this.searchCount > 0){
        this.productForm = null;
        this.searchProduct();
      }
    },
    searchText(val) {
      bus.$emit('search-text-changed', val);
    }
  },

  computed: {
    ...mapGetters({
      vg_searchFilter: "searchproduct/searchFilter",
      vg_doSearch: "searchproduct/doSearch",
      vg_userAddress: "location/userAddress",
      vg_locationNearBy: "location/nearby",
      vg_selectedStore: "location/selected",
      vg_userId: "getLoggedInUserId",     
    })
  },

  methods: {
    /**
     * Go to location detail page
     */
    goToLocationProductDetail(item) {
      this.$router.push({ name: 'LocationProductDetail', 
        params: { 
          business_slug: this.$route.params.business_slug,
          store_slug: this.vg_selectedStore.slug, 
          product_id: item.id 
        } ,
        query: this.refineQuery(this.$route.query),
      })
    },

    /**
     * Reset filter text
     */
    resetFilterText() {
      this.searchText = "";
      this.searchProduct();
    },
  
    // Get product and locations result from api
    searchProduct: _.debounce(async function(e) {
      this.is_loading = true;
      let nearestLocationIds = []; 
      // now search changed to selected location only 
      nearestLocationIds.push(this.vg_selectedStore.id);
      let res = await SearchProductApis.newSearch({
        product_name: this.searchText.trim(), 
        search_params: this.vg_searchFilter,
        nearest_location_ids: nearestLocationIds
      });

      if(res.status == 200) {
        // remove discontuned , 0 varaints or all varinats on available
        let data = res.data.payload.filter(item => {
          if(item.discontinued == false && item.variants.length > 0 && Helpers.isAllVariantOutOfStock(item.variants) == false){
            return item;
          }
        })
        this.searchedProducts = data;
      } else {
        this.searchedProducts = [];
      }
      this.is_loading = false;
    }, 500),
    
    goBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push({ name: "HomePage", query: this.$route.query, });
    },

    refineQuery(query) {
      // remove category key if available
      if(query.hasOwnProperty("category")){
        delete query["category"];
      } 
      if(query.hasOwnProperty("product_name")){
        delete query["product_name"];
      } 
      return query;
    },

    ...mapActions({
      va_snackbar: "snackbar/setSnackbar",
      va_setSearchFilter: "searchproduct/setSearchFilter",
      va_setSelectedLocation: "location/setSelected",
    })
  }
};
</script>

